import styled from 'styled-components';

export const Info = styled.div`
   color: ${({ theme }) => theme.primaryBlueDark};
   display: flex;
   flex-flow: row wrap;
   align-items: center;
   justify-content: flex-start;
`;

export const InfoList = styled.ul`
   margin-left: 25px;
   display: flex;
   flex-direction: column;
   list-style: none;
   > * {
      margin: 10px 0 10px 5px;
   }
   @media only screen and (max-width: 400px) {
      margin: unset;
      padding: 0 15px;
   }
`;
